import { useEffect } from "react";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import Marquee from "@/components/Marquee";
import Library from "@/components/Library";
import Reviews from "@/components/Reviews";
import WatchSection from "@/components/WatchSection";
import Manifesto from "@/components/Manifesto";
import LeadMagnet from "@/components/LeadMagnet";
import GlobalReach from "@/components/GlobalReach";
import Footer from "@/components/Footer";
import PanchatantraPage from "@/pages/Panchatantra";
import ContactPage from "@/pages/Contact";

function Home() {
  return (
    <>
      <Hero />
      <Marquee />
      <Library />
      <Reviews />
      <WatchSection />
      <Manifesto />
      <LeadMagnet />
      <GlobalReach />
    </>
  );
}

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App bg-emerald-ink text-cream" data-testid="app-root">
      <BrowserRouter>
        <Nav />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/panchatantra" element={<PanchatantraPage />} />
            <Route path="/contact" element={<ContactPage variant="parents" />} />
            <Route path="/publishers" element={<ContactPage variant="publishers" />} />
          </Routes>
        </main>
        <Footer />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "#082A20",
              border: "1px solid rgba(212,175,55,0.4)",
              color: "#FDFBF7",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
